module.exports = __webpack_public_path__ + "img/6.86fc7ba4.jpg";